// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai-chat {
  position: fixed;
  top: var(--ai-chat-top, 56px);
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  max-width: 100vw;
  background: var(--ion-background-color, #ffffff);
  color: var(--ion-text-color, #1f2937);
  border-left: 1px solid var(--ion-color-light-shade, #d5dbe5);
  box-shadow: -12px 0 32px rgba(15, 23, 42, 0.12);
}

.ai-chat--mobile {
  top: 0;
  left: 0;
  width: 100%;
  border-left: 0;
  padding-top: var(--ion-safe-area-top, 0);
}

.ai-chat__maniglia {
  position: absolute;
  left: -6px;
  top: 0;
  bottom: 0;
  width: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: col-resize;
  touch-action: none;
  z-index: 1;
}

.ai-chat__maniglia-segno {
  width: 4px;
  height: 48px;
  border-radius: 2px;
  background: var(--ion-color-medium-tint, #9aa6b8);
}

.ai-chat__testata {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 8px 8px 8px 20px;
  border-bottom: 1px solid var(--ion-color-light-shade, #e3e7ee);
}

.ai-chat__titoli {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.ai-chat__sottotitolo {
  font-size: 12px;
  color: var(--ion-color-medium);
}

.ai-chat__titolo {
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ai-chat__messaggi {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.ai-chat__spinner {
  align-self: center;
}

.ai-chat__vuoto {
  margin: auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
  color: var(--ion-color-medium-shade);
  font-size: 14px;
}
.ai-chat__vuoto b {
  color: var(--ion-text-color, #1f2937);
  font-size: 16px;
}

.ai-chat__vuoto-icona {
  font-size: 36px;
}

.ai-chat__esempi {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-top: 8px;
}

.ai-chat__esempio {
  padding: 10px 14px;
  border: 1px solid var(--ion-color-light-shade, #e3e7ee);
  border-radius: 10px;
  background: transparent;
  color: var(--ion-text-color, #1f2937);
  font: inherit;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
}
.ai-chat__esempio:hover:not(:disabled) {
  border-color: var(--ion-color-primary);
}

.ai-chat__domanda {
  align-self: flex-end;
  max-width: 80%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.ai-chat__bolla {
  padding: 10px 14px;
  border-radius: 14px 14px 4px 14px;
  background: rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.12);
  font-size: 14px;
  line-height: 1.45;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.ai-chat__ora {
  font-size: 11px;
  color: var(--ion-color-medium);
}

.ai-chat__risposta {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  line-height: 1.5;
}

.ai-chat__pensando {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--ion-color-medium);
}

.ai-chat__markdown {
  overflow-wrap: anywhere;
}
.ai-chat__markdown ::ng-deep p {
  margin: 0 0 8px;
}
.ai-chat__markdown ::ng-deep table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  margin: 4px 0 8px;
  display: block;
  overflow-x: auto;
}
.ai-chat__markdown ::ng-deep th,
.ai-chat__markdown ::ng-deep td {
  padding: 6px 10px;
  border: 1px solid var(--ion-color-light-shade, #e3e7ee);
  text-align: left;
}
.ai-chat__markdown ::ng-deep th {
  background: var(--ion-color-light, #f4f6fa);
}
.ai-chat__markdown ::ng-deep code {
  font-size: 12px;
}
.ai-chat__markdown ::ng-deep pre {
  overflow-x: auto;
  padding: 8px;
  border-radius: 8px;
  background: var(--ion-color-light, #f4f6fa);
}

.ai-chat__cursore {
  display: inline-block;
  width: 8px;
  height: 16px;
  margin-top: -4px;
  background: var(--ion-color-primary);
  animation: ai-chat-lampeggia 1s steps(2, start) infinite;
}

@keyframes ai-chat-lampeggia {
  to {
    visibility: hidden;
  }
}
.ai-chat__errore,
.ai-chat__interrotta {
  font-size: 13px;
}

.ai-chat__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--ion-color-medium);
}

.ai-chat__chip {
  padding: 2px 8px;
  border-radius: 10px;
  background: var(--ion-color-light, #f1f3f7);
  color: var(--ion-color-dark-tint, #374151);
}

.ai-chat__copia {
  margin: 0;
}

.ai-chat__piede {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 20px 16px;
  border-top: 1px solid var(--ion-color-light-shade, #e3e7ee);
}

.ai-chat__avviso-quota {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  padding: 10px 12px;
  border-radius: 10px;
  background: rgba(var(--ion-color-danger-rgb, 197, 0, 15), 0.08);
  font-size: 13px;
}
.ai-chat__avviso-quota ion-icon {
  flex-shrink: 0;
  font-size: 18px;
}

.ai-chat__consumi {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ai-chat__consumi-testo {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  font-size: 12px;
  color: var(--ion-color-medium-shade);
}

.ai-chat__barra {
  height: 6px;
  border-radius: 3px;
  background: var(--ion-color-light-shade, #e7ebf2);
  overflow: hidden;
}

.ai-chat__barra-valore {
  height: 6px;
  border-radius: 3px;
  background: var(--ion-color-primary);
}

.ai-chat__barra-valore--attenzione {
  background: var(--ion-color-warning);
}

.ai-chat__barra-valore--esaurita {
  background: var(--ion-color-danger);
}

.ai-chat__composer {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding: 6px 6px 6px 14px;
  border: 1px solid var(--ion-color-medium-tint, #c9d2df);
  border-radius: 12px;
}
.ai-chat__composer:focus-within {
  border-color: var(--ion-color-primary);
}

.ai-chat__campo {
  flex: 1;
  min-height: 44px;
  max-height: 160px;
  padding: 4px 0;
  border: 0;
  outline: none;
  resize: vertical;
  background: transparent;
  color: inherit;
  font: inherit;
  font-size: 14px;
}

.ai-chat__stop,
.ai-chat__invia {
  margin: 0;
  --border-radius: 10px;
}

.ai-chat__nota {
  font-size: 11px;
  color: var(--ion-color-medium);
}`, "",{"version":3,"sources":["webpack://./src/app/_components/ai-chat/ai-chat-panel/ai-chat-panel.component.scss"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,6BAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gDAAA;EACA,qCAAA;EACA,4DAAA;EACA,+CAAA;AAAF;;AAGA;EACE,MAAA;EACA,OAAA;EACA,WAAA;EACA,cAAA;EACA,wCAAA;AAAF;;AAGA;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AAAF;;AAGA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,iDAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,8DAAA;AAAF;;AAGA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAAF;;AAGA;EACE,eAAA;EACA,8BAAA;AAAF;;AAGA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,OAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,oCAAA;EACA,eAAA;AAAF;AAEE;EACE,qCAAA;EACA,eAAA;AAAJ;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;AADF;;AAIA;EACE,kBAAA;EACA,uDAAA;EACA,mBAAA;EACA,uBAAA;EACA,qCAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AADF;AAGE;EACE,sCAAA;AADJ;;AAKA;EACE,oBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;AAFF;;AAKA;EACE,kBAAA;EACA,iCAAA;EACA,kEAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,eAAA;EACA,8BAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,8BAAA;AAFF;;AAMA;EACE,uBAAA;AAHF;AAMI;EACE,eAAA;AAJN;AAOI;EACE,WAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AALN;AAQI;;EAEE,iBAAA;EACA,uDAAA;EACA,gBAAA;AANN;AASI;EACE,2CAAA;AAPN;AAUI;EACE,eAAA;AARN;AAWI;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,2CAAA;AATN;;AAcA;EACE,qBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,oCAAA;EACA,wDAAA;AAXF;;AAcA;EACE;IACE,kBAAA;EAXF;AACF;AAcA;;EAEE,eAAA;AAZF;;AAeA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,8BAAA;AAZF;;AAeA;EACE,gBAAA;EACA,mBAAA;EACA,2CAAA;EACA,0CAAA;AAZF;;AAeA;EACE,SAAA;AAZF;;AAeA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,2DAAA;AAZF;;AAeA;EACE,aAAA;EACA,QAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,+DAAA;EACA,eAAA;AAZF;AAcE;EACE,cAAA;EACA,eAAA;AAZJ;;AAgBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAbF;;AAgBA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;EACA,eAAA;EACA,oCAAA;AAbF;;AAgBA;EACE,WAAA;EACA,kBAAA;EACA,iDAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,WAAA;EACA,kBAAA;EACA,oCAAA;AAbF;;AAgBA;EACE,oCAAA;AAbF;;AAgBA;EACE,mCAAA;AAbF;;AAgBA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,yBAAA;EACA,uDAAA;EACA,mBAAA;AAbF;AAeE;EACE,sCAAA;AAbJ;;AAiBA;EACE,OAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;AAdF;;AAiBA;;EAEE,SAAA;EACA,qBAAA;AAdF;;AAiBA;EACE,eAAA;EACA,8BAAA;AAdF","sourcesContent":["// Feature 159: pannello sopra il contenuto, sotto la toolbar dell'header; a schermo intero sotto i 768 px.\n.ai-chat {\n  position: fixed;\n  top: var(--ai-chat-top, 56px);\n  right: 0;\n  bottom: 0;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  max-width: 100vw;\n  background: var(--ion-background-color, #ffffff);\n  color: var(--ion-text-color, #1f2937);\n  border-left: 1px solid var(--ion-color-light-shade, #d5dbe5);\n  box-shadow: -12px 0 32px rgba(15, 23, 42, 0.12);\n}\n\n.ai-chat--mobile {\n  top: 0;\n  left: 0;\n  width: 100%;\n  border-left: 0;\n  padding-top: var(--ion-safe-area-top, 0);\n}\n\n.ai-chat__maniglia {\n  position: absolute;\n  left: -6px;\n  top: 0;\n  bottom: 0;\n  width: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: col-resize;\n  touch-action: none;\n  z-index: 1;\n}\n\n.ai-chat__maniglia-segno {\n  width: 4px;\n  height: 48px;\n  border-radius: 2px;\n  background: var(--ion-color-medium-tint, #9aa6b8);\n}\n\n.ai-chat__testata {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  padding: 8px 8px 8px 20px;\n  border-bottom: 1px solid var(--ion-color-light-shade, #e3e7ee);\n}\n\n.ai-chat__titoli {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.ai-chat__sottotitolo {\n  font-size: 12px;\n  color: var(--ion-color-medium);\n}\n\n.ai-chat__titolo {\n  font-size: 16px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ai-chat__messaggi {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.ai-chat__spinner {\n  align-self: center;\n}\n\n.ai-chat__vuoto {\n  margin: auto 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  text-align: center;\n  color: var(--ion-color-medium-shade);\n  font-size: 14px;\n\n  b {\n    color: var(--ion-text-color, #1f2937);\n    font-size: 16px;\n  }\n}\n\n.ai-chat__vuoto-icona {\n  font-size: 36px;\n}\n\n.ai-chat__esempi {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n  margin-top: 8px;\n}\n\n.ai-chat__esempio {\n  padding: 10px 14px;\n  border: 1px solid var(--ion-color-light-shade, #e3e7ee);\n  border-radius: 10px;\n  background: transparent;\n  color: var(--ion-text-color, #1f2937);\n  font: inherit;\n  font-size: 14px;\n  text-align: left;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    border-color: var(--ion-color-primary);\n  }\n}\n\n.ai-chat__domanda {\n  align-self: flex-end;\n  max-width: 80%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n}\n\n.ai-chat__bolla {\n  padding: 10px 14px;\n  border-radius: 14px 14px 4px 14px;\n  background: rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.12);\n  font-size: 14px;\n  line-height: 1.45;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.ai-chat__ora {\n  font-size: 11px;\n  color: var(--ion-color-medium);\n}\n\n.ai-chat__risposta {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.ai-chat__pensando {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--ion-color-medium);\n}\n\n// Il markdown arriva come HTML sanificato da Angular: gli stili devono raggiungerlo fuori dall'incapsulamento.\n.ai-chat__markdown {\n  overflow-wrap: anywhere;\n\n  ::ng-deep {\n    p {\n      margin: 0 0 8px;\n    }\n\n    table {\n      width: 100%;\n      border-collapse: collapse;\n      font-size: 13px;\n      margin: 4px 0 8px;\n      display: block;\n      overflow-x: auto;\n    }\n\n    th,\n    td {\n      padding: 6px 10px;\n      border: 1px solid var(--ion-color-light-shade, #e3e7ee);\n      text-align: left;\n    }\n\n    th {\n      background: var(--ion-color-light, #f4f6fa);\n    }\n\n    code {\n      font-size: 12px;\n    }\n\n    pre {\n      overflow-x: auto;\n      padding: 8px;\n      border-radius: 8px;\n      background: var(--ion-color-light, #f4f6fa);\n    }\n  }\n}\n\n.ai-chat__cursore {\n  display: inline-block;\n  width: 8px;\n  height: 16px;\n  margin-top: -4px;\n  background: var(--ion-color-primary);\n  animation: ai-chat-lampeggia 1s steps(2, start) infinite;\n}\n\n@keyframes ai-chat-lampeggia {\n  to {\n    visibility: hidden;\n  }\n}\n\n.ai-chat__errore,\n.ai-chat__interrotta {\n  font-size: 13px;\n}\n\n.ai-chat__meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--ion-color-medium);\n}\n\n.ai-chat__chip {\n  padding: 2px 8px;\n  border-radius: 10px;\n  background: var(--ion-color-light, #f1f3f7);\n  color: var(--ion-color-dark-tint, #374151);\n}\n\n.ai-chat__copia {\n  margin: 0;\n}\n\n.ai-chat__piede {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 12px 20px 16px;\n  border-top: 1px solid var(--ion-color-light-shade, #e3e7ee);\n}\n\n.ai-chat__avviso-quota {\n  display: flex;\n  gap: 8px;\n  align-items: flex-start;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: rgba(var(--ion-color-danger-rgb, 197, 0, 15), 0.08);\n  font-size: 13px;\n\n  ion-icon {\n    flex-shrink: 0;\n    font-size: 18px;\n  }\n}\n\n.ai-chat__consumi {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.ai-chat__consumi-testo {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: 12px;\n  color: var(--ion-color-medium-shade);\n}\n\n.ai-chat__barra {\n  height: 6px;\n  border-radius: 3px;\n  background: var(--ion-color-light-shade, #e7ebf2);\n  overflow: hidden;\n}\n\n.ai-chat__barra-valore {\n  height: 6px;\n  border-radius: 3px;\n  background: var(--ion-color-primary);\n}\n\n.ai-chat__barra-valore--attenzione {\n  background: var(--ion-color-warning);\n}\n\n.ai-chat__barra-valore--esaurita {\n  background: var(--ion-color-danger);\n}\n\n.ai-chat__composer {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n  padding: 6px 6px 6px 14px;\n  border: 1px solid var(--ion-color-medium-tint, #c9d2df);\n  border-radius: 12px;\n\n  &:focus-within {\n    border-color: var(--ion-color-primary);\n  }\n}\n\n.ai-chat__campo {\n  flex: 1;\n  min-height: 44px;\n  max-height: 160px;\n  padding: 4px 0;\n  border: 0;\n  outline: none;\n  resize: vertical;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  font-size: 14px;\n}\n\n.ai-chat__stop,\n.ai-chat__invia {\n  margin: 0;\n  --border-radius: 10px;\n}\n\n.ai-chat__nota {\n  font-size: 11px;\n  color: var(--ion-color-medium);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
